import { PassportType } from 'components/common/parse-excel/parse-passport';
import * as React from 'react';

interface PassportCsvResult {
  passportValue?: any;
  passportCsvData: PassportType[];
  setPassportValue: (value?: any) => void;
  setPassportCsvData: (value: PassportType[]) => void;
}

const context = React.createContext<PassportCsvResult>({
  passportValue: undefined,
  passportCsvData: [],
  setPassportValue() {},
  setPassportCsvData() {},
});

const { Provider } = context;

interface PassportCsvProviderProps {
  children: React.ReactNode;
}

export function PassportCsvProvider(props: PassportCsvProviderProps) {
  const [passportValue, _setPassportValue] = React.useState<any>([]);
  const [passportCsvData, _setPassportCsvData] = React.useState<PassportType[]>(
    [],
  );

  const setPassportValue = React.useCallback((value: any) => {
    _setPassportValue(value);
  }, []);

  const setPassportCsvData = React.useCallback((value: PassportType[]) => {
    _setPassportCsvData(value);
  }, []);

  return (
    <Provider
      value={{
        passportValue,
        setPassportValue,
        setPassportCsvData,
        passportCsvData,
      }}
    >
      {props.children}
    </Provider>
  );
}

export function usePassportCsv() {
  return React.useContext(context);
}
